function getDataLayer(): Record<string, unknown>[] | undefined {
  if (typeof window === 'undefined') return undefined
  return (window as { dataLayer?: Record<string, unknown>[] }).dataLayer
}

export type FormSubmitFormularart = 'Camp Anmeldung' | 'Newsletter-Anmeldung'

export interface GTMFormSubmitCampPayload {
  event: 'form_submit'
  form_id: string
  form_target?: string
  formularart: FormSubmitFormularart
  campform?: string
  newsletter_bestellt?: 'ja' | 'nein'
  camp_id?: string
  camp_title?: string
}

export interface GTMFormSubmitNewsletterPayload {
  event: 'form_submit'
  form_id: string
  form_target?: string
  formularart: 'Newsletter-Anmeldung'
}

export type GTMFormSubmitPayload = GTMFormSubmitCampPayload | GTMFormSubmitNewsletterPayload

export function pushFormSubmitToDataLayer(payload: GTMFormSubmitPayload): void {
  const dataLayer = getDataLayer()
  if (!dataLayer) return
  dataLayer.push(payload as unknown as Record<string, unknown>)
}

export function pushCampRegistrationFormSubmit(params: {
  formId?: string
  formTarget?: string
  campform?: string
  newsletterBestellt: boolean
  campId?: string
  campTitle?: string
}): void {
  pushFormSubmitToDataLayer({
    event: 'form_submit',
    form_id: params.formId ?? 'camp-anmeldung',
    form_target: params.formTarget,
    formularart: 'Camp Anmeldung',
    campform: params.campform ?? undefined,
    newsletter_bestellt: params.newsletterBestellt ? 'ja' : 'nein',
    camp_id: params.campId,
    camp_title: params.campTitle,
  })
}

export function pushNewsletterFormSubmit(params: {
  formId: string
  formTarget?: string
}): void {
  pushFormSubmitToDataLayer({
    event: 'form_submit',
    form_id: params.formId,
    form_target: params.formTarget,
    formularart: 'Newsletter-Anmeldung',
  })
}
